<template>
    <div class="px-4 pt-3 pb-4 border-bottom">
        <div class="font-size-14 font-weight-600 black--text">Live Chat</div>

        <div class="mt-2">
            <v-row>
                <v-col>
                    <div class="d-flex align-center gap-10">
                        <div>
                            <v-avatar>
                                <v-img
                                    :src="
                                        detail.user_image ||
                                        require('@/assets/img/siswa.svg')
                                    "
                                />
                            </v-avatar>
                        </div>
                        <div>
                            <div
                                class="font-weight-bold black--text font-size-14"
                            >
                                {{ detail.student_name }}
                            </div>
                            <div class="font-size-12" style="margin-top: -3px">
                                Kelas {{ detail.grade }}
                            </div>
                        </div>
                    </div>
                </v-col>

                <v-col>
                    <div class="d-flex align-center gap-10">
                        <div>
                            <v-img
                                :src="require('@/assets/apps/star.svg')"
                                height="35"
                                width="35"
                            />
                        </div>
                        <div>
                            <div class="font-size-12 grey--text">Rating</div>
                            <div
                                class="font-weight-bold font-size-14"
                                style="margin-top: -3px; color: #f2af17"
                            >
                                {{ detail.rating }}
                            </div>
                        </div>
                    </div>
                </v-col>

                <v-col>
                    <div class="d-flex align-center gap-10">
                        <div>
                            <v-img
                                :src="require('@/assets/apps/chat.svg')"
                                height="35"
                                width="35"
                            />
                        </div>
                        <div>
                            <div class="font-size-12 grey--text">
                                Jumlah Sesi
                            </div>
                            <div
                                class="font-weight-bold font-size-14"
                                style="margin-top: -3px; color: #0e97d6"
                            >
                                {{ detail.total_session }}
                            </div>
                        </div>
                    </div>
                </v-col>

                <v-col>
                    <div class="d-flex align-center gap-10">
                        <div>
                            <v-img
                                :src="require('@/assets/apps/duration.svg')"
                                height="35"
                                width="35"
                            />
                        </div>
                        <div>
                            <div class="font-size-12 grey--text">
                                Durasi Konsul
                            </div>
                            <div
                                class="font-weight-bold font-size-14"
                                style="margin-top: -3px; color: #3f45ce"
                            >
                                {{ detail.consul_duration }} menit
                            </div>
                        </div>
                    </div>
                </v-col>

                <v-col>
                    <div class="d-flex align-center gap-10">
                        <div>
                            <v-img
                                :src="require('@/assets/apps/timeout.svg')"
                                height="35"
                                width="35"
                            />
                        </div>
                        <div>
                            <div class="font-size-12 grey--text">
                                Total Active Time
                            </div>
                            <div
                                class="font-weight-bold font-size-14"
                                style="margin-top: -3px; color: #f2af17"
                            >
                                {{ detail.total_active_time }} menit
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "consultant-chat-detail",
    props: {
        detail: { type: Array },
    },
    data() {
        return {
            loading: false,
            data: [],
        };
    },
};
</script>



// WEBPACK FOOTER //
// ConsulChatDetail.vue?7e55eb25